<template>
  <div
    v-if="show"
    class="loading-overlay-container"
  >
    <!-- Opaque background -->
    <div class="loading-overlay-modal-background" />

    <!-- Inner body -->
    <div class="loading-inner-container cert-capture-form">
      <div
        class="modal-close"
        style="top: 1.2rem !important; right: 1.2rem !important;"
        @click="onCancel"
      />
      <CertCaptureFormComponent
        :centered="true"
        :on-success="onCertSuccess"
        :destination="destination"
      />
    </div>
  </div>
</template>

<script>
import CertCaptureFormComponent from '../CertCapture/CertCaptureFormComponent.vue'

/**
 * The CertCapture Modal Component for CertCaptureFormComponent.
 * @displayName CertCapture Modal
 */
export default {
  name: 'CertCaptureModalComponent',
  components: {
    CertCaptureFormComponent
  },
  props: [
    'invoice_id',
    'show',
    'onCancel',
    'onCertSuccess',
    'destination'
  ],
  data () {
    return {}
  },
  computed: {},
  mounted () {},
  methods: {}
}
</script>

<style scoped></style>
